import { AxiosResponse } from 'axios';
import $http from 'services/http.service';
import { clientId } from 'utils/helper.utils';

type LogoutResponse = { message: string };

export async function logout(): Promise<AxiosResponse<LogoutResponse>> {
  const data = new URLSearchParams({ client_id: clientId ?? '' });
  const response = await $http.post<LogoutResponse>('/logout', data, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });

  return response;
}
